import { updateCanvasStoryboards } from "@/store/supabaseSlice";
import { StoryboardDelta } from "@/store/zustand/changeLedgerTypes";
import { useSupabaseStore } from "@/store/zustand/supabaseStore";
import { usePagesStore } from "@/store/zustand/pagesStore";
import { Storyboard } from "@/utils/types";
import { useDispatch } from "react-redux";

const useUpdateStoryboardSize = (canvas: any) => {
  const supabaseClient = useSupabaseStore((state) => state.supabaseClient);
  const dipsatch = useDispatch();

  const setSize = async (
    storyboard: Storyboard,
    width: number | null,
    height: number | null,
  ) => {
    if (!supabaseClient) {
      console.error("Supabase client not available");
      return;
    }

    // Get page info for deltas
    const pagesStore = usePagesStore.getState();
    const selectedPageId = pagesStore.selectedPageId[canvas.id];
    const pageConfigPath = selectedPageId
      ? pagesStore.getPageSourcePath(canvas.id, selectedPageId)
      : undefined;

    const storyboardDeltas: StoryboardDelta[] = [
      {
        changeType: "update" as const,
        storyboardId: storyboard.id,
        pageId: selectedPageId || "",
        pageConfigPath,
        storyboardUpdateDict: {
          width: width || storyboard.width,
          height: height || storyboard.height,
        },
      },
    ];

    updateCanvasStoryboards(canvas.id, storyboardDeltas, undefined, true);
  };

  return { setSize };
};

export default useUpdateStoryboardSize;
